// extracted by mini-css-extract-plugin
module.exports = {"embedTopSection":"embed-top-bar_embedTopSection_3VD","titleAuthorSection":"embed-top-bar_titleAuthorSection_1sr","buttonSection":"embed-top-bar_buttonSection_XKS"};